import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../Header/Header";
import Select from 'react-select';
import foodbrand from "../../assets/foodbrand@2x.png";
import "./styleDomPersonal.css";

const country = [
  {
    label: 'Mexico',
    image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/fc/Flag_of_Mexico.svg/1920px-Flag_of_Mexico.svg.png',
    value: 'MX',
  }
];

function DirDomPersonal() {

  const navigate = useNavigate();


  const onTest = async () => {

    navigate("/CompDomPersonal", {
      state: { user: "userTest" },
    });
    
  };

  const handleChange = (selectedOption) => {
    const setSelectedOption = selectedOption.value;
  };
  const [blContinue, setBlContinue] = useState(true);


  const style = {
    control: base => ({
      ...base,
      height: "52px !important",
      borderRadius: "0.375rem !important",
      boxShadow: "none !important",
      borderColor: "#c4cbd1 !important",
      "&:hover": {
        borderColor: "#c4cbd1 !important"
      }

    })
  };

  return (
    <>
      <div className="initBack_P2 animate__animated animate__fadeIn">
        <Header
          imgBack={true}
          rutaBack="/HomeDomPersonal"
          title="Domicilio personal"
          name="DirDomPersonal"
        />

        <div className="containerRender">
          <div className="containerInfo_P2">
            <div className="containerIdent_P2">
              <div className="txtOp_P2">Domicilio Personal</div>
              <div className="subTitle">Dirección donde normalmente reside o pernocta.</div>
              <hr className="separadorLine" />
              <div>
                <span className="txtSubtitle">Pais</span>
                <div>
                  <Select
                    styles={style}
                    options={country}
                    onChange={handleChange}
                    value={{ value: 'MX', label: 'Mexico', image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/fc/Flag_of_Mexico.svg/1920px-Flag_of_Mexico.svg.png' }}
                    formatOptionLabel={country => (
                      <div className="containerDom">
                        <div className="pais">{country.value} {country.label}</div>
                        <div className="paisBandera">
                          <img className="bandera" src={country.image} />
                        </div>
                      </div>
                    )}
                    placeholder="Selecciona tu País"
                  />
                </div>
              </div>
              <hr className="lineSimple" />
              <div className='btnContinue'>
                {!blContinue ? (
                  <>
                    <button className='btnVer_P3'>
                      <span className='txtVer_P3'>Continuar</span>
                    </button>
                  </>
                ) : (
                  <>
                    <button className='button_P2 animate__animated animate__fadeIn' onClick={onTest}>
                      <span className='txtButton_P2'>Continuar</span>
                    </button>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="footer">
          {/* <div className="containerCont_P2">
            <button className="button_P2" onClick={onTest}>
              <span className="txtButton_P2">Confirmar</span>
            </button>
          </div> */}
          <div className="imageContainer_P2">
            <img src={foodbrand} className="imgFooter_P2" />
          </div>
        </div>
      </div>
    </>
  );
}

export default DirDomPersonal;
